import { render, staticRenderFns } from "./GroupIndex.vue?vue&type=template&id=148df4a6&scoped=true"
import script from "./GroupIndex.vue?vue&type=script&lang=js"
export * from "./GroupIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148df4a6",
  null
  
)

export default component.exports